// Carry Roll ScenarioSet — add/remove scenarios + filters (10.1).

import { useStore } from '../../store';
import { useAlert } from '@ascend/alert';

export function ScenarioSet() {
  const addScenario = useStore((s) => s.addScenario);
  const request = useStore((s) => s.request);
  const scenarios = useStore((s) => s.scenarios);
  const clearScenarios = useStore((s) => s.clearScenarios);
  const { confirm } = useAlert();

  const handleClear = async () => {
    const ok = await confirm({
      title: 'Clear all scenarios?',
      message: `This removes all ${scenarios.length} scenario${scenarios.length === 1 ? '' : 's'} from the comparison. This cannot be undone.`,
      danger: true,
      confirmLabel: 'Clear all',
    });
    if (ok) clearScenarios();
  };

  return (
    <div className="panel" data-testid="scenario-set">
      <h3 className="subsection-title">
        Scenarios ({scenarios.length})
      </h3>
      <div className="flex gap-2 flex-wrap">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => addScenario(`Shot ${scenarios.length + 1}`, request)}
        >
          + Add current shot
        </button>
        {scenarios.length > 0 && (
          <button type="button" className="btn" onClick={handleClear}>
            Clear all
          </button>
        )}
      </div>
      {scenarios.length === 0 ? (
        <p className="mt-2 text-sm" style={{ color: 'var(--color-text-muted)' }}>
          No scenarios yet. Use &quot;Add current shot&quot; above to start comparing.
        </p>
      ) : (
        <ul className="mt-2 text-sm" style={{ color: 'var(--color-text-muted)' }}>
          {scenarios.map((s) => (
            <li key={s.id}>• {s.label}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
